import 'firebase/functions';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SmsService {
  fc = firebase.functions();
  constructor (private http: HttpClient
  ) { }

  sendSMS(message: string, phoneNumber: string): Observable<any> {
    const url = `${environment.constants.cloudfunctionsURL}sms-sendSMS`;
    return from(this.getAuthIdToken()).pipe(
      switchMap(idToken =>
        this.http.post(url, { message, phoneNumber }, {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`
          })
        })
      )
    );
  }

  sendStudyNotificationToFacility(facilityId: string): Promise<void> {
    const url = `${environment.constants.cloudfunctionsURL}sms-sendStudyNotificationToFacility`;
    return this.getAuthIdToken().then(idToken =>
      this.http.post(url, { facilityId }, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${idToken}`
        })
      }).toPromise()
    ).then(() => undefined);
  }

  private async getAuthIdToken(): Promise<string> {
    const user = firebase.auth().currentUser;
    if (!user) throw new Error('Not signed in');
    return user.getIdToken();
  }
}
